module.exports = __webpack_public_path__ + "img/tradeRepublic-dark.c6b05d5a.png";